// ✅ src/components/tenant/ViewTenant.js
import React from "react";
import "../../styles/UserForm.css";

function ViewTenant({ tenantData, onClose, onEdit }) {
  if (!tenantData) return null;

  return (
    <div className="uf-modal" onClick={onClose}>
      <div className="uf-card" onClick={(e) => e.stopPropagation()}>

        {/* ✅ Header */}
        <div className="uf-header">
          <h5 className="text-white">Tenant Details</h5>
          <button onClick={onClose}>✕</button>
        </div>

        {/* ✅ Body */}
        <div className="uf-body">
          <div className="uf-grid">

            {/* Name */}
            <div>
              <label className="form-label">Name</label>
              <input
                className="form-control"
                readOnly
                value={tenantData.name || ""}
              />
            </div>

            {/* Code */}
            <div>
              <label className="form-label">Code</label>
              <input
                className="form-control"
                readOnly
                value={tenantData.code || ""}
              />
            </div>

            {/* Domain */}
            <div>
              <label className="form-label">Domain</label>
              <input
                className="form-control"
                readOnly
                value={tenantData.domain || ""}
              />
            </div>

            {/* Contact Email */}
            <div>
              <label className="form-label">Contact Email</label>
              <input
                type="email"
                className="form-control"
                readOnly
                value={tenantData.contact_email || ""}
              />
            </div>

            {/* Logo */}
            <div>
              <label className="form-label">Logo URL</label>
              <input
                className="form-control"
                readOnly
                value={tenantData.logo_url || ""}
              />
            </div>

            {/* Theme Color */}
            <div>
              <label className="form-label">Theme Color</label>
              <input
                type="color"
                className="form-control form-control-color"
                readOnly
                value={tenantData.theme_color || "#007bff"}
              />
            </div>

            {/* Status */}
            <div>
              <label className="form-label d-block">Status</label>
              <span
                className={`badge ${
                  tenantData.status === "Active"
                    ? "bg-success"
                    : "bg-secondary"
                }`}
              >
                {tenantData.status}
              </span>
            </div>

            {/* Created At */}
            <div>
              <label className="form-label">Created</label>
              <input
                className="form-control"
                readOnly
                value={
                  tenantData.created_at?.split("T")[0] ||
                  ""
                }
              />
            </div>

          </div>
        </div>

        {/* ✅ Footer */}
        <div className="uf-actions">
          <button type="button" className="btn btn-cancel" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={() => onEdit?.(tenantData)}>
            Edit Tenant
          </button>
        </div>

      </div>
    </div>
  );
}

export default ViewTenant;
